<!--
 * @Author: Bai YanShuo
 * @Date: 2023-03-07 09:30:25
 * @LastEditors: Bai YanShuo
 * @LastEditTime: 2023-03-08 11:07:47
 * @FilePath: /web/src/components/InvalidCharMsg.vue
 * @Description:
-->
<template>
  <div v-if="visible" class="invalid-feedback d-block">
    {{ msg }}
  </div>
</template>

<script>
export default {
  props: {
    msg: {
      type: String,
      default: 'Invalid name , the following characters are not allowed < > : " / \ | ? *'
    },
    visible: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped></style>
